<template>
  <div class="iscanvas">
    <button type="button" class="btn btn-primary" v-on:click="getPdf()">
      导出PDF
    </button>
    <div id="pdfDom" v-if="!loading" style="background-color: #f5f5f5">
      <div class="box">
        <div class="title">健康总评</div>
        <Summary :list.sync="navData[0].data" />
      </div>
      <div class="box">
        <div class="title">生理风险</div>
        <Physiology :list.sync="navData[1].data" />
      </div>
      <div class="box">
        <div class="title">脑血管</div>
        <Brain :list.sync="navData[2].data" />
      </div>
      <div class="box">
        <div class="title">糖尿病</div>
        <Diabetes :list.sync="navData[3].data" />
      </div>
      <div class="box">
        <div class="title">健康建议</div>
        <Healthy :list.sync="navData[4].data" />
      </div>
    </div>
  </div>
</template>
<script>
import Summary from "@/components/Summary"
import Physiology from "@/components/Physiology"
import Brain from "@/components/Brain"
import Diabetes from "@/components/Diabetes"
import Healthy from "@/components/Healthy"
import Report from "../models/Report"
import html2canvas from "html2canvas"
export default {
  components: { Summary, Physiology, Brain, Diabetes, Healthy },
  data () {
    return {
      htmlTitle: '健康报告',
      active: 0,
      loading: true,
      navData: [
        { text: '健康总评', url: 'Summary', list: 'summary' },
        { text: '生理风险系统', url: 'Physiology', list: 'physiology' },
        { text: '脑血管风险', url: 'Brain', list: 'brain' },
        { text: '糖尿病风险', url: 'Diabetes', list: 'diabetes' },
        { text: '健康管理建议', url: 'Healthy', list: 'healthy' }],
    }
  },
  computed: {
    id () {
      return this.$route.query.id || ''
    },
    user_no () {
      return this.$route.query.user_no || ''
    }
  },
  methods: {
    buildImg () {
      html2canvas(document.getElementsByClassName('iscanvas')[0]).then(canvas => {
        this.finished = true;
        document.getElementsByClassName('iscanvas')[0].appendChild(canvas);
      });
    },
    oylstatus (status) {
      let level;
      switch (status) {
        case 1:
          level = 5
          break;
        case 2:
          level = 4
          break;
        case 3:
          level = 3
          break;
        case 4:
          level = 2
          break;
        case 5:
          level = 1
          break;
      }
      return level
    }
  },
  created () {
    let params = {
      user_no: this.user_no,
      test_report_id: this.id
    }
    Report.getReports({ ...params }, (res, err) => {
      this.loading = true
      if (!err) {
        res.healthy.forEach(e => {
          e.btntxt = "查看建议";
          e.showCon = false
        });
        res.special[0].descArr = res.special[0].desc.split('\\r\\n');
        res.special[1].descArr = res.special[1].desc.split('\\r\\n')
        res.diabetes.descArr = res.diabetes.diabetes_desc.split('\\r\\n');
        res.brain.descArr = res.brain.brain_desc.split('\\r\\n');
        res.special[4].status = this.oylstatus(res.special[4].status)
        console.log('adsfa', res.special[0])
        this.navData[0].data = res.special;
        this.navData[1].data = res.physiology;
        this.navData[2].data = res.brain;
        this.navData[3].data = res.diabetes;
        this.navData[4].data = {
          healthy: res.healthy,
          marks: res.marks
        }
        this.loading = false
      }
    })
  }
}
</script>
<style lang="scss" >
.van-tabs--line .van-tabs__wrap {
  height: 80px !important;
  line-height: 80px;
  margin-bottom: 20px;
}
.van-tabs__wrap--scrollable .van-tab {
  flex: 0 0 30% !important;
  font-size: 30px;
}
.vantabs {
  font-size: 30px;
}
.box {
  padding: 30px;
}
.box .title {
  margin-bottom: 20px;
}
</style>